import { Injectable, signal } from '@angular/core';
import { ContentfulService } from '../contentful/contentful.service';
import { CategoryFields, CategoryItem } from './category.model';

@Injectable({ providedIn: 'root' })
export class CategoriesStore {
  readonly categories = signal<CategoryItem[]>([]);
  readonly loading = signal(true);
  readonly error = signal(false);

  constructor(private readonly contentfulService: ContentfulService) {
    this.contentfulService
      .getEntries<CategoryFields>({ contentType: 'productCategory', limit: 50, query: { include: 1 } })
      .subscribe({
        next: (res) => {
          const assetMap = new Map<string, string>();
          const includes = (res as unknown as {
            includes?: { Asset?: Array<{ sys: { id: string }; fields: { file?: { url?: string } } }> };
          }).includes;
          if (includes?.Asset) {
            for (const asset of includes.Asset) {
              const url = asset.fields?.file?.url;
              if (url) assetMap.set(asset.sys.id, url.startsWith('//') ? `https:${url}` : url);
            }
          }

          const mapped = res.items.map((item) => {
            const iconLink = item.fields['icon'] as { sys: { id: string } } | undefined;
            const iconUrl = iconLink ? (assetMap.get(iconLink.sys.id) ?? null) : null;
            return {
              id: item.sys.id,
              name: item.fields['name'] as string,
              slug: (item.fields['slug'] as string | undefined) ?? '',
              order: (item.fields['order'] as number | undefined) ?? 999,
              iconUrl,
            };
          });
          mapped.sort((a, b) => a.order - b.order);
          this.categories.set(mapped);
          this.loading.set(false);
        },
        error: () => {
          this.error.set(true);
          this.loading.set(false);
        },
      });
  }

  bySlug(slug: string | null): CategoryItem | undefined {
    return slug ? this.categories().find((c) => c.slug === slug) : undefined;
  }
}
